import type { PaletteRange } from '@mui/material/styles/createPalette';

export const yellow = {
  50: '#fff9e1',
  100: '#fff0b3',
  200: '#ffe780',
  300: '#ffd95a',
  400: '#ffd039',
  500: '#fec817',
  600: '#ebba10',
  700: '#d9a600',
  800: '#765700',
  900: '#4a3600',
  950: '#291e00',
} satisfies PaletteRange;

export const chateauGreen = {
  50: '#edfcf2',
  100: '#d2f9de',
  200: '#aaf0c4',
  300: '#72e3a3',
  400: '#3acd7e',
  500: '#16b364',
  600: '#0a9150',
  700: '#087442',
  800: '#095c37',
  900: '#094b2f',
  950: '#032b1a',
} satisfies PaletteRange;

export const green = {
  50: '#f0fdfa',
  100: '#ccfbef',
  200: '#9af5e1',
  300: '#66bb6a',
  400: '#4caf50',
  500: '#2e7d32',
  600: '#267129',
  700: '#1b5e20',
  800: '#154d1b',
  900: '#0f3d16',
  950: '#07280d',
} satisfies PaletteRange;

export const neonBlue = {
  50: '#f0f7ff',
  100: '#e0f0ff',
  200: '#beddff',
  300: '#92c5ff',
  400: '#58a6ff',
  500: '#1e61a3',
  600: '#184e82',
  700: '#123b61',
  800: '#0c2741',
  900: '#061420',
  950: '#030a10',
} satisfies PaletteRange;

export const blue = {
  50: '#f2f5fc',
  100: '#e5ebf9',
  200: '#cbd7f2',
  300: '#a7bbe8',
  400: '#6685db',
  500: '#3a64d1',
  600: '#3157bd',
  700: '#2d50b0',
  800: '#294aa8',
  900: '#031f5f',
  950: '#021541',
} satisfies PaletteRange;

export const navy = {
  50: '#f3f5f9',
  100: '#e7ecf4',
  200: '#d0d9e9',
  300: '#afbcd6',
  400: '#8294b8',
  500: '#61779f',
  600: '#455f8c',
  700: '#304a80',
  800: '#1c356b',
  900: '#031f5f',
  950: '#021541',
} satisfies PaletteRange;

export const nevada = {
  50: '#fbfcfe',
  100: '#f0f4f8',
  200: '#dde7ee',
  300: '#cdd7e1',
  400: '#9fa6ad',
  500: '#636b74',
  600: '#555e68',
  700: '#32383e',
  800: '#202427',
  900: '#121517',
  950: '#090a0b',
} satisfies PaletteRange;

export const redOrange = {
  50: '#fef3f2',
  100: '#fee4e2',
  200: '#ffcdc9',
  300: '#ef5350',
  400: '#e53935',
  500: '#d32f2f',
  600: '#c62828',
  700: '#b71c1c',
  800: '#9a221a',
  900: '#80231c',
  950: '#460d09',
} satisfies PaletteRange;

export const royalBlue = {
  50: '#ecf3ff',
  100: '#dce8ff',
  200: '#c0d4ff',
  300: '#9bb6ff',
  400: '#738dff',
  500: '#5265ff',
  600: '#3339f8',
  700: '#3739de',
  800: '#2225b1',
  900: '#24298b',
  950: '#151651',
} satisfies PaletteRange;

export const shakespeare = {
  50: '#ecfdff',
  100: '#cff7fe',
  200: '#a4eefd',
  300: '#4fc3f7',
  400: '#29b6f6',
  500: '#0288d1',
  600: '#0277bd',
  700: '#01579b',
  800: '#014577',
  900: '#123849',
  950: '#082f44',
} satisfies PaletteRange;

export const stormGrey = {
  50: '#f9fafb',
  100: '#f1f1f4',
  200: '#dcdfe4',
  300: '#b3b9c6',
  400: '#8a94a6',
  500: '#667085',
  600: '#565e73',
  700: '#434a60',
  800: '#313749',
  900: '#212636',
  950: '#121621',
} satisfies PaletteRange;

export const tomatoOrange = {
  50: '#fff3ed',
  100: '#ffe2d4',
  200: '#ffc1a8',
  300: '#ffa280',
  400: '#ff9771',
  500: '#ff6c47',
  600: '#fe4011',
  700: '#ed3507',
  800: '#9f2c0f',
  900: '#7e1110',
  950: '#440608',
} satisfies PaletteRange;
